import React from 'react'
import ClipLoader from "react-spinners/ClipLoader";
import orderIcon from "../../images/order icon.svg";
import userIcon from "../../images/users icon.svg";
import riderIcon from "../../images/dispatch riders icon.svg";
import { useState } from 'react'
import DashHeader from '../mini/DashHeader';
import { useDashStatsQuery } from '../../redux/services/dashBoardApi';
import { useAllOrdersQuery } from "../../redux/services/ordersApi";
import Pagination from "../mini/Pagination";

const Dash = () => {
    
    const [ searchQuery, setSearchQuery ] = useState('')
    const { data: dashApiData, error: dashApiError, isLoading: dashApiLoading, isSuccess: dashApiSuccess } = useDashStatsQuery()
    let dashStats

    if (!dashApiLoading) {
        if (dashApiSuccess) {
            dashStats = dashApiData.data
        } else {
            console.log(dashApiError)
        }
    }


    const { data: orderApiData } = useAllOrdersQuery()

    // pagination
    const [currentPage, setCurrentPage] = useState(1)
    const [dataPerPage] = useState(9)

    const indexOfLastData = currentPage * dataPerPage
    const indexOfFirstData = indexOfLastData - dataPerPage
    const currentTableDatas = orderApiData?.data?.slice(indexOfFirstData, indexOfLastData)

    const paginate = pg => {
        setCurrentPage(pg)
    }

    let table

    if(searchQuery){
        table = orderApiData?.orders
    } else {
        table = currentTableDatas
    }
            

    
    const renderList = table?.filter((val) => {
        return val.status.toLowerCase().includes(searchQuery.toLowerCase()) 
                    || val.createdAt.toLowerCase().includes(searchQuery.toLowerCase())
                    || val.paymentMethod.toLowerCase().includes(searchQuery.toLowerCase())
                    || val._id.toLowerCase().includes(searchQuery.toLowerCase())
    }).map((OH, index) => {
        
        const { _id, createdAt, paymentMethod, fareAmount, status } = OH
        Date.longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const d = new Date(createdAt)
        const time = d.toLocaleString('en-Us', { hour: 'numeric', minute: 'numeric', hour12: true })
        const date = Date.longMonths[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear()
        let txtColor

        if (status === "on going" || status === "pending") {
            txtColor = "text-warning"            
        } else if (status === "complete") {
            txtColor = "text-success" 
        } else {
            txtColor = "text-danger"
        }

        return (
            <tr key={index}>
                <td title={_id}>{_id.substring(0, 7) + '...'}</td>
                <td>{time}</td>
                <td>{date}</td>
                <td>&#8358; {fareAmount}</td>
                <td>{paymentMethod}</td>
                <td className={txtColor+" tstatus"}>{status}</td>
            </tr>
        )

    })


    return (
        <>
            {
                dashApiLoading ?
                <div className="loader">
                    <ClipLoader color="#fdc51c" loading={dashApiLoading} size={80} /> 
                </div> :
                <div className='pull-up'>
                    <DashHeader title="Dashboard" />
                    {/* search */}
                    <div>
                        <div className="input form-control w-40 py-0 my-1 me-5">
                            <i className="ri-search-line ri-lg pe-2"></i>
                            <input type="text" placeholder="Search Users By Order ID, Payment, Date or Status" className="w-75 p-2 ps-0" value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}} />
                        </div>
                    </div>
                    <div className='row my-5'>
                        <div className="col-md-3 mb-md-0 mb-4">
                            <div className="me-3 dash-items p-4 bg-white">
                                <h6 className="fw-bold">Total Amount Earned</h6>
                                <h3 className='mt-4 fw-bold'>&#8358; {dashStats?.totalEarned.toLocaleString()}</h3>
                            </div>
                        </div>
                        <div className="col-md-3 mb-md-0 mb-4">
                            <div className="me-3 dash-items p-4 bg-white">
                                <h6 className="fw-bold">Total Orders</h6>
                                <h3 className='mt-4 fw-bold'>
                                    <i className="dash-icon p-2 rounded-3 me-3">
                                        <img src={orderIcon} alt="icon" />
                                    </i>
                                    {dashStats?.totalOrders}
                                </h3>
                            </div>
                        </div>
                        <div className="col-md-3 mb-md-0 mb-4">
                            <div className="me-3 dash-items p-4 bg-white">
                                <h6 className="fw-bold">Total Users</h6>
                                <h3 className='mt-4 fw-bold'>
                                    <i className="dash-icon p-2 rounded-3 me-3">
                                        <img src={userIcon} alt="icon" />
                                    </i>
                                    {dashStats?.totalUsers}
                                </h3>
                            </div>
                        </div>
                        <div className="col-md-3 mb-md-0 mb-4">
                            <div className="me-3 dash-items p-4 bg-white">
                                <h6 className="fw-bold">Total Riders</h6>
                                <h3 className='mt-4 fw-bold'>
                                    <i className="dash-icon p-2 rounded-3 me-3">
                                        <img src={riderIcon} alt="icon" />
                                    </i>
                                    {dashStats?.totalRiders}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <h4>Recent Activities</h4>
                    <section>
                        <div className="table-responsive my-4">
                            <table className="table text-center">
                                <thead>
                                    <tr>
                                        <th>Order ID</th>
                                        <th>Time</th>
                                        <th>Date</th>
                                        <th>Fare Amount</th>
                                        <th>Payment</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {renderList}
                                </tbody>
                            </table>

                        </div>
                        <Pagination 
                        paginate={paginate} 
                        dataPerPage={dataPerPage} 
                        totalData={orderApiData?.data.length}
                        curPage={currentPage}
                        pageLen={currentTableDatas?.length} />
                    </section>
                </div>
            }
        </>
    )
}

export default Dash
